module.exports = __webpack_public_path__ + "assets/img/kv-0b8282e4.jpg";